import { Component, Input, OnInit } from '@angular/core'
import { ChannelMonthlyRatingDistItem } from '@tokeet-frontend/reviews'
import * as lodash from 'lodash'

@Component({
  selector: 'app-review-montly-avg-rating-tooltip',
  templateUrl: './review-montly-avg-rating-tooltip.component.html',
  styleUrls: ['./review-montly-avg-rating-tooltip.component.scss'],
  host: {
    class: 'dropdown-shadow',
  },
})
export class ReviewMontlyAvgRatingTooltipComponent implements OnInit {
  @Input() previousItem: ChannelMonthlyRatingDistItem
  @Input() item: ChannelMonthlyRatingDistItem
  @Input() monthLabel: string

  ratingCategories = [
    { label: '0 - 1.9', range: '0-1.9', value: 1 },
    { label: '2 - 2.9', range: '2-2.9', value: 2 },
    { label: '3 - 3.9', range: '3-3.9', value: 3 },
    { label: '4 - 4.4', range: '4-4.4', value: 4 },
    { label: '4.5 - 4.7', range: '4.5-4.7', value: 4.5 },
    { label: '4.8 - 5', range: '4.8-5', value: 5 },
  ].reverse()

  constructor() {}

  ngOnInit(): void {}

  getTotalCount(item: ChannelMonthlyRatingDistItem) {
    return lodash.sumBy(item?.ratings, (t) => t.count)
  }

  getLevelCount(item: ChannelMonthlyRatingDistItem, range: string) {
    return lodash.find(item?.ratings, (t) => t.range === range)?.count || 0
  }

  isRatingDown() {
    const currentMonthRating = this.item?.averageOverallRating || 0
    const lastMonthRating = this.previousItem?.averageOverallRating || 0
    if (!currentMonthRating) return false
    if (currentMonthRating >= lastMonthRating) return false
    else return true
  }
}
